import axios from "axios";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useState } from "react";
import { jwtDecode } from "jwt-decode";
//import { Link } from "react-router-dom";

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errormessage, setErrormessage] = useState('');
  //create here for submit method
  const submit = async (e) => {    
    e.preventDefault();
    const user = {
      username: username,
      password: password,
    };
    //create here post request
    const { data } = await
      axios.post(`${global.config.live_url}/token/`, user,{mode: 'no-cors', headers: { 'Content-Type': 'application/json' ,"Access-Control-Allow-Origin":"*","Access-Control-Allow-Methods":"DELETE, POST, GET, OPTIONS","Access-Control-Allow-Headers": "Content-Type, Authorization, X-Requested-With",}, withCredentials: true });
    //Now initialize the access & refresh token in localsotrage    
    if (data === null || data==='undefined') {      
      setErrormessage('Either Mobileno or password are not correct.')
    } else {
      console.log('yes I am here');
      //localStorage.clear();
      localStorage.removeItem("access_token")
      localStorage.removeItem("user_id")
      localStorage.removeItem("access")
      localStorage.removeItem("refresh_token")
      localStorage.setItem('access_token', data.access);
      localStorage.setItem('user_id', JSON.stringify(jwtDecode(data.access).user_id));
      localStorage.setItem('access', JSON.stringify(jwtDecode(data.access).token_type));
      localStorage.setItem('refresh_token', data.refresh); 
      axios.defaults.headers.common['Authorization'] = `Bearer ${data['access']}`;  
      window.location.href = '/';
    }    
   
  }
  return (
    <div className="modal" id="myModal">
      <form onSubmit={submit}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Login</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body">
              <div className="mb-3 row">
                <label htmlFor="staticEmail" className="col-sm-2 col-form-label">
                  Mobileno
                </label>
                <div className="col-sm-10">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Mobile Number"
                    required
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
                <label htmlFor="inputPassword" className="col-sm-2 col-form-label">
                  Password
                </label>
                <div className="col-sm-10">
                  <input
                    type="password"
                    className="form-control"
                    name="password"
                    placeholder="Enter password"
                    value={password}
                    required
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>
              <div className="mb-3 row">
              {errormessage ? <div className="alert alert-danger" role="alert">
                  {errormessage}
              </div> : ''}
              </div>
              <div className="mb-3 row">
                <div className="d-grid gap-2">
                  <button type="submit" className="btn btn-warning">
                    Login
                  </button>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
export default Login;
